import styled from 'styled-components';

export const Users = styled.div`
  background: white;
  min-height: 100%;
`
